<template>
    <v-dialog content-class="top-dialog" v-model="show" :max-width="width" :persistent="persistent" @keydown.esc="choose(false)">
        <v-card tile>
            <v-toolbar v-if="Boolean(title)" dark :color="color" dense flat>
                <v-icon v-if="Boolean(icon)" left>{{ icon }}</v-icon>
                <v-toolbar-title class="white--text" v-text="title" />
            </v-toolbar>
            <v-card-text class="body-1 text-body-1 py-3" v-html="message" />
            <v-card-text>
                <v-text-field v-if="password && password.length" v-model="unlock" ref="pwd" persistent-hint :messages="password" outlined dense>
                    <template v-slot:message="{ message }">
                        <span
                            class="ml-n3"
                            v-html="`Please type <span style='color: red; font-weight: bold'>${message}</span> in the box to continue`"
                        ></span>
                    </template>
                </v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn v-if="Boolean(buttonFalseText)" :color="buttonFalseColor" :text="buttonFalseFlat" @click="choose(false)">
                    {{ buttonFalseText }}
                </v-btn>
                <v-btn
                    v-if="Boolean(buttonTrueText)"
                    :color="buttonTrueColor"
                    :text="buttonTrueFlat"
                    @click="choose(true)"
                    :disabled="password && password.length ? unlock.localeCompare(password, undefined, { sensitivity: 'accent' }) !== 0 : false"
                >
                    {{ buttonTrueText }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { VCard, VCardActions, VCardText, VDialog, VIcon, VToolbar, VToolbarTitle, VSpacer, VBtn } from 'vuetify/lib'

export default {
    components: {
        VCard,
        VCardActions,
        VCardText,
        VDialog,
        VIcon,
        VToolbar,
        VToolbarTitle,
        VSpacer,
        VBtn
    },
    props: {
        buttonTrueText: {
            type: String,
            default: 'Yes'
        },
        buttonFalseText: {
            type: String,
            default: 'No'
        },
        buttonTrueColor: {
            type: String,
            default: 'primary'
        },
        buttonFalseColor: {
            type: String,
            default: 'grey'
        },
        buttonFalseFlat: {
            type: Boolean,
            default: true
        },
        buttonTrueFlat: {
            type: Boolean,
            default: true
        },
        color: {
            type: String,
            default: 'warning'
        },
        icon: {
            type: String,
            default() {
                return this.$vuetify.icons.values.warning
            }
        },
        message: {
            type: String,
            required: true
        },
        persistent: Boolean,
        title: {
            type: String
        },
        width: {
            type: Number,
            default: 450
        },
        show: {
            type: Boolean,
            required: true
        },
        password: {
            type: String
        }
    },
    data() {
        return {
            value: false,
            unlock: ''
        }
    },
    mounted() {
        document.addEventListener('keyup', this.onEnterPressed)
    },
    destroyed() {
        document.removeEventListener('keyup', this.onEnterPressed)
    },
    methods: {
        onEnterPressed(e) {
            if (e.keyCode === 13) {
                e.stopPropagation()
                this.choose(true)
            }
        },
        choose(value) {
            this.$emit('result', value)
            this.value = value
        }
    },

    watch: {
        show(val) {
            if (val) {
                this.unlock = ''
                let vm = this
                if (this.password && this.password.length) {
                    setTimeout(() => vm.$refs.pwd.focus())
                }
            }
        }
    }
}
</script>

<style scoped>
    .v-dialog__content {
        align-items: flex-start;
        justify-content: flex-start;
    }
</style>